module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_300-5ad7adad67d75325120d849f0994c716.png";